var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 39.9999C31.046 39.9999 40.0003 31.0456 40.0003 19.9999C40.0003 8.95418 31.046 -0.00012207 20.0003 -0.00012207C8.95457 -0.00012207 0.000259399 8.95418 0.000259399 19.9999C0.000259399 31.0456 8.95457 39.9999 20.0003 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000259399 20C0.000259399 8.95425 8.95464 -0.00012207 20.0003 -0.00012207C31.0459 -0.00012207 40.0003 8.95425 40.0003 20",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 10.4347C12.1739 7.52078 14.2218 5.08656 16.9565 4.48929C16.5362 4.39757 16.1002 4.34781 15.6521 4.34781C12.2903 4.34781 9.56519 7.07297 9.56519 10.4348C9.56519 13.7966 12.2903 16.5217 15.6521 16.5217C16.1 16.5217 16.5361 16.472 16.9565 16.3802C14.2218 15.7829 12.1739 13.3487 12.1739 10.4347V10.4347Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 4.78249L20.4317 6.111H21.8286L20.6984 6.93217L21.1301 8.26069L19.9999 7.43967L18.8698 8.26069L19.3015 6.93217L18.1713 6.111H19.5682L19.9999 4.78249Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6114 7.3912L17.043 8.7198H18.44L17.3098 9.54089L17.7415 10.8694L16.6114 10.0484L15.4811 10.8694L15.9129 9.54089L14.7826 8.7198H16.1796L16.6114 7.3912Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3889 7.3912L23.8207 8.7198H25.2176L24.0873 9.54089L24.5191 10.8694L23.3889 10.0484L22.2587 10.8694L22.6905 9.54089L21.5603 8.7198H22.9572L23.3889 7.3912Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0846 11.3042L22.5163 12.6328H23.9132L22.783 13.4539L23.2148 14.7824L22.0846 13.9614L20.9544 14.7824L21.3862 13.4539L20.256 12.6328H21.6528L22.0846 11.3042Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9156 11.3042L18.3472 12.6328H19.7443L18.614 13.4539L19.0458 14.7824L17.9156 13.9614L16.7854 14.7824L17.2171 13.4539L16.0869 12.6328H17.4839L17.9156 11.3042Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.37e52306918a7d9886ba04ee40f38f51.svg";
export { ForwardRef as ReactComponent };